import React from 'react'
import { NavLink } from 'react-router-dom'

export default function SiteHeader() {
  return (
    <nav className="retro-site-header navbar navbar-expand sticky-top" aria-label="Nawigacja główna">
      <div className="container retro-site-header-inner">
        <NavLink className="retro-brand" to="/">
          StareKomputery<span>.pl</span>
        </NavLink>

        <ul className="retro-nav-list navbar-nav ml-auto d-flex align-items-center">
          <li className="nav-item">
            <NavLink className="retro-nav-link" to="/" end>Start</NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="retro-nav-link" to="/collection">Zbiory</NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="retro-nav-link" to="/links">Linki</NavLink>
          </li>
        </ul>
      </div>
    </nav>
  )
}
